import type { TableRowStyleType } from 'components/editor/grid/reduxStore/tableRowDefaultStyleSlice';
import { TableRowDefaultSelectorsEnum } from 'components/editor/grid/reduxStore/tableRowDefaultStyleSlice';
import type { defaultStyles } from './useAccordionData';
import type { AllTextDefaultStylesType } from 'components/editor/grid/reduxStore/textDefaultStylingSlice';
import {
  AllTextDefaultSelectors,
  TextDefaultSelectorsEnum,
  TableDefaultClassNamesEnum,
} from 'components/editor/grid/reduxStore/textDefaultStylingSlice';

const getEnumKeyByValue = (enumObj, value: string) => {
  return Object.keys(enumObj).find((key) => enumObj[key] === value);
};

export const tableStyleToRowClassMap = {
  [TableDefaultClassNamesEnum.TABLE_BODY]: TableRowDefaultSelectorsEnum.BODY,
  [TableDefaultClassNamesEnum.TABLE_HEADER]: TableRowDefaultSelectorsEnum.HEADER,
  [TableDefaultClassNamesEnum.TABLE_FOOTER]: TableRowDefaultSelectorsEnum.FOOTER,
  [TableDefaultClassNamesEnum.TABLE_SUBTOTAL]: TableRowDefaultSelectorsEnum.SUBTOTAL,
  [TableDefaultClassNamesEnum.TABLE_TOTAL]: TableRowDefaultSelectorsEnum.TOTAL,
};

export const combineDefaultStyles = (
  textStyles: Record<string, AllTextDefaultStylesType>,
  rowStyles?: Record<string, TableRowStyleType>
): defaultStyles[] => {
  if (!textStyles) return [];
  return Object.keys(textStyles).map((key) => {
    const selectorKey = getEnumKeyByValue(AllTextDefaultSelectors, key) as string;
    const title = TableDefaultClassNamesEnum[selectorKey] || TextDefaultSelectorsEnum[selectorKey];

    return {
      title: title,
      textStyles: textStyles[key],
      rowStyles: rowStyles ? rowStyles[tableStyleToRowClassMap[key]] : undefined,
    };
  });
};
